import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "../../shared/shared.module";
import { FrontendComponent } from "./frontend.component";
import { LoginModule } from "./login/login.module";
import { RouterModule } from "@angular/router";
import { BackofficeModule } from "../backoffice/backoffice.module";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [
    FrontendComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    SharedModule,
    LoginModule,
    RouterModule,
    BackofficeModule
  ]
})
export class FrontendModule {}

